import { Grid, Typography } from "@mui/material";
import { results } from "@/utils/staticData/aboutUsData";

import Section from "@/components/Section";

const Results = () => {
  return (
    <Section pt={{ xs: 5, md: 6, lg: 12.5 }} pb={{ xs: 5, md: 6, lg: 12.5 }}>
      <Grid container columnSpacing={{ xs: 3, lg: 7.5 }}>
        <Grid item xs={12} md={8} mb={{ xs: 5, lg: 0 }}>
          <Typography
            variant="h2"
            mb={{ xs: 3, lg: 2 }}
            maxWidth={700}
            textAlign={{ xs: "center", md: "start" }}
          >
            Result that speak for themselfs
          </Typography>
          <Typography
            variant="subtitle1"
            component="p"
            color="text.secondary"
            maxWidth={700}
            textAlign={{ xs: "center", md: "start" }}
          >
            From optimizing fleet efficiency to empowering individuals with precise tracking, the results achieved with Trackmate speak for themselves.
          </Typography>
        </Grid>

        <Grid item xs={12} md={4}>
          <Grid container spacing={{ xs: 4, md: 6, lg: 12.5 }}>
            {results.map(({ title, description }, index) => (
              <Grid item xs={12} key={index}>
                <Typography
                  variant="h4"
                  component="h3"
                  mb={{ xs: 1, md: 2 }}
                  color="text.primary"
                  textAlign={{ xs: "center", md: "start" }}
                >
                  {title}
                </Typography>
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  component="p"
                  textAlign={{ xs: "center", md: "start" }}
                  maxWidth={{ md: index !== 0 ? 342 : "100%" }}
                >
                  {description}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Section>
  );
};

export default Results;
